"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AGgrid_table_component_1 = require("../../../../common/tables/AGgrid_table_component");
var react_paginate_1 = require("../../../../common/react_pagination/react_paginate");
var table_data_1 = require("../../../../constants/table_data");
var array_helpers_1 = require("../../../../utils/array_helpers");
var reports_helper_1 = require("../reports_helper");
var react_query_1 = require("react-query");
var react_redux_1 = require("react-redux");
var moment = require("moment");
require("../reports.scss");
var react_hot_toast_1 = require("react-hot-toast");
var BaggingLifeCycleLite = function (_a) {
    var searchTerm = _a.searchTerm, bagbarcode = _a.bagbarcode, startDate = _a.startDate, endDate = _a.endDate, cashstatus = _a.cashstatus, isFilterButton = _a.isFilterButton, filterSelectedLabs = _a.filterSelectedLabs, filterSelectedCities = _a.filterSelectedCities, PageLimit = _a.PageLimit, setpageCount = _a.setpageCount, pageCount = _a.pageCount, setLifeCycleList = _a.setLifeCycleList, lifeCycleList = _a.lifeCycleList;
    var labList = (0, react_redux_1.useSelector)(function (state) { return state.appConfigList.labList; });
    var _b = React.useState(0), totalPageCount = _b[0], setTotalPageCount = _b[1];
    var _c = React.useState(), errorMessage = _c[0], setErrorMessage = _c[1];
    var _d = React.useState(0), totalCount = _d[0], setTotalCount = _d[1];
    var refetch = (0, react_query_1.useQuery)(['bagging-lifecycle', pageCount], function () {
        var currentPage = pageCount < 1 ? 1 : pageCount;
        var payload = {
            is_lighter_version: true
        };
        if (filterSelectedCities.length > 0) {
            var selectedStateAndCity = (0, reports_helper_1.generateStateAndCitiesFromSelectedCities)(filterSelectedCities);
            payload['state'] =
                selectedStateAndCity.states.length >= 30
                    ? ['ALL']
                    : selectedStateAndCity.states;
            payload['city'] =
                selectedStateAndCity.cities.length >= 500
                    ? ['ALL']
                    : selectedStateAndCity.cities;
        }
        if (searchTerm.length >= 3) {
            payload['search_string'] = searchTerm.toLocaleLowerCase().trim();
        }
        if (bagbarcode.length) {
            payload['bag_barcode'] = bagbarcode.toLocaleUpperCase().trim();
        }
        if (startDate && endDate) {
            var dateRangeArr = {
                start_date: moment(startDate).format('YYYY-MM-DD'),
                end_date: moment(endDate).format('YYYY-MM-DD'),
            };
            payload['date_range'] = dateRangeArr;
        }
        else {
            react_hot_toast_1.default.error('Please select a date range', { duration: 2000 });
            return;
        }
        if (filterSelectedLabs.length > 0) {
            var labCode = (0, array_helpers_1.selecteAllOption)(filterSelectedLabs, labList);
            payload['lab_code'] = labCode;
        }
        if (cashstatus !== null) {
            payload['status'] = cashstatus.label;
        }
        payload['page'] = currentPage;
        payload['size'] = PageLimit ? parseInt(PageLimit.value.toString()) : 50;
        (0, reports_helper_1.baggingLifeCycleReports)(payload)
            .then(function (response) {
            var pageSize = PageLimit
                ? parseInt(PageLimit.value.toString())
                : 50;
            var count = Math.ceil(response.count / pageSize);
            setErrorMessage('');
            setTotalPageCount(count);
            setLifeCycleList(response.result);
            setTotalCount(response.count);
        })
            .catch(function (err) {
            setErrorMessage(err);
            setLifeCycleList([]);
            setTotalCount(0);
            setpageCount(0);
            setTotalPageCount(0);
        });
    }).refetch;
    var handlePageClick = function (data) {
        var currentPage = data.selected + 1;
        setpageCount(currentPage);
    };
    React.useEffect(function () {
        if (pageCount != 1) {
            setpageCount(1);
        }
        else {
            refetch();
        }
    }, [isFilterButton]);
    return (React.createElement("div", { className: "fe-wrapper pay  -fe-wrapper" },
        React.createElement("div", { className: "unclickablerow custom-pagination-table bagging-lifecycle-table-wrapper" },
            React.createElement(AGgrid_table_component_1.default, { isSortable: true, columnDefs: table_data_1.default.BAGGING_LIFECYCLE_COLUMNS, rows: lifeCycleList, pagination: false, enableCellTextSelection: true, className: 'bagging-lifecycle-table', errorMessage: errorMessage, isMessageUpdated: true }),
            React.createElement(react_paginate_1.default, { onPageChange: handlePageClick, pageCount: totalPageCount, currentPage: pageCount, total: totalCount, dataLength: lifeCycleList === null || lifeCycleList === void 0 ? void 0 : lifeCycleList.length, currentPageLimits: PageLimit === null || PageLimit === void 0 ? void 0 : PageLimit.value }))));
};
exports.default = BaggingLifeCycleLite;
